import { CloseIcon, DeleteIcon, EditIcon, ViewIcon } from '@chakra-ui/icons';
import {
    Alert,
    AlertDescription,
    Badge,
    Box,
    Button,
    Card,
    CardBody,
    CardHeader,
    Center,
    Checkbox,
    Divider,
    Flex,
    FormControl,
    FormLabel,
    Heading,
    HStack,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Popover,
    PopoverArrow,
    PopoverBody,
    PopoverContent,
    PopoverTrigger,
    SimpleGrid,
    Table,
    Tbody,
    Td,
    Text,
    Textarea,
    Th,
    Thead,
    Tooltip,
    Tr,
    useDisclosure,
    useToast,
    VStack
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { FaBook, FaChevronRight, FaClock, FaHourglassHalf, FaLongArrowAltDown, FaMapMarkedAlt, FaShare, FaSync, FaTimes, FaUser } from 'react-icons/fa';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { getSelectStyles, hasPermission, useTableColors } from '../../Utils';
import { cancelPickup, fetchAllCouriers, fetchLabLocationsOutside, fetchRouteBySearch, finishPickups, getAllFacilitiesOutside, getAllPickups, getPickupsStats, searchPickups, transferPickup } from '../../api';
import AccessDenied from '../../components/AccessDenied';
import Loading from '../../components/Loading/Loading';
import Pagination from '../../components/Pagination';
import PickupImageLightbox from '../../components/PickupImageLightbox';
import PopoverId from '../../components/PopoverId';
import TitleHeader from '../../components/TitleHeader';
import CreatePickupModal from './CreatePickupModal';
import EditPickupModal from './EditPickupModal';
import PickupNotes from './PickupNotes';


// import { SimpleGrid, Card, CardHeader, CardBody, Heading, Text, HStack, VStack, Box } from '@chakra-ui/react';
import { FaBoxes, FaCheckCircle, FaClipboardList, FaPhoneAlt, FaRoute } from 'react-icons/fa';



const statusOptions = [
    { value: 'PENDING', label: 'Pending' },
    { value: 'PICKED_UP', label: 'Picked Up' },
];

const attnOptions = [
    { value: 'WITHCOUNT', label: '1+ Samples Pickups' },
    { value: 'ONCALL', label: 'On Call' },
    { value: 'ZERO', label: 'Picked-up 0 samples' },
];


const AllPickups = () => {
    const { isOpen: isDeleteModalOpen, onOpen: onOpenDeleteModal, onClose: onCloseDeleteModal } = useDisclosure();
    const { isOpen: isNoteModalOpen, onOpen: onNoteModalOpen, onClose: onCloseNoterModal } = useDisclosure();
    const { isOpen: isTransferModalOpen, onOpen: onOpenTransferModal, onClose: onCloseTransferModal } = useDisclosure();

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const toast = useToast()
    const [allPickups, setAllPickups] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingProcess, setLoadingProcess] = useState(false);
    const [selectedPickup, setSelectedPickup] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [error, setError] = useState(null);
    const itemsPerPage = 25;

    const [pickupLocation, setPickupLocation] = useState(null);
    const [courier, setCourier] = useState(null);
    const [dropOffLocation, setDropOffLocation] = useState(null);
    const [route, setRoute] = useState(null);

    const [searching, setSearching] = useState(false);

    const [cancellationReason, setCancellationReason] = useState('');
    const [modalError, setModalError] = useState('');

    const [labLocations, setLabLocations] = useState([]);
    const [statusSelected, setSelectedStatus] = useState([]);
    const [attnSelected, setSelectedAttn] = useState([]);

    const [showCheckboxes, setShowCheckboxes] = useState(false);
    const [selectedPickups, setSelectedPickups] = useState([]);
    const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
    const [cancelReason, setCancelReason] = useState("");

    const [facilities, setFacilities] = useState([]);
    const [couriers, setCouriers] = useState([]);

    const [statistics, setStatistics] = useState([]);

    const [transfering, setTransfering] = useState(false)
    const [showFilter, setShowFilter] = useState(false)


    const coolors = useTableColors()


    const [transferCourier, setTransferCourier] = useState(null);
    const handleTransferPickup = async () => {
        try {

            setTransfering(true)
            const newCourierName = transferCourier.label.split('┃')[0].trim();


            console.log("TC")
            console.log(transferCourier)
            console.log("NCN")
            console.log(newCourierName)
            const updateParams = {
                courier: transferCourier.value,
                oldCourierName: selectedPickup?.courier?.name,
                oldCourierId: selectedPickup?.courier?._id,
                newCourierName: newCourierName
            };

            const response = await transferPickup(updateParams, selectedPickup._id);

            if (response.success) {
                setAllPickups(prevPickups =>
                    prevPickups.map(pickup =>
                        pickup._id === selectedPickup._id
                            ? {
                                ...pickup,
                                courier: {
                                    _id: transferCourier.value,
                                    name: newCourierName
                                }
                            }
                            : pickup
                    )
                );

                toast({
                    title: "Great!",
                    description: "Pickup transferred",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });

                setTransferCourier(null)
                onCloseTransferModal();
            } else {
                toast({
                    title: "Oops!",
                    description: response.error,
                    status: "error",
                    duration: 4000,
                    isClosable: true,
                });
            }

            setTransfering(false)
        } catch (error) {
            console.error('Error transferring pickup:', error);
        }
    };


    const toggleCheckboxes = () => {
        setShowCheckboxes(!showCheckboxes);
        setSelectedPickups([]); // optional: clear selections each toggle
    };

    const handleCheckboxChange = (pickupId) => {
        setSelectedPickups((prev) =>
            prev.includes(pickupId)
                ? prev.filter((id) => id !== pickupId)
                : [...prev, pickupId]
        );
    };


    // 1) Finish With Count Update
    const handleFinishWithCount = async () => {
        const confirmed = window.confirm(
            "Are you sure you want to finish these pickups WITH a count update?"
        );
        if (!confirmed) return; // User canceled the action

        try {
            const response = await finishPickups({
                pickupIds: selectedPickups,
                action: "WITH_COUNT",
            });

            if (response.success) {
                // Remove updated pickups from local state
                setAllPickups((prev) =>
                    prev.filter((pickup) => !selectedPickups.includes(pickup._id))
                );
                setSelectedPickups([]); // Clear selection
            }
        } catch (err) {
            console.error("Error finishing with count:", err);
        }
    };

    // 2) Finish Without Count Update
    const handleFinishWithoutCount = async () => {
        const confirmed = window.confirm(
            "Are you sure you want to finish these pickups WITHOUT updating the count?"
        );
        if (!confirmed) return;

        try {
            const response = await finishPickups({
                pickupIds: selectedPickups,
                action: "WITHOUT_COUNT",
            });

            if (response.success) {
                // Remove updated pickups from local state
                setAllPickups((prev) =>
                    prev.filter((pickup) => !selectedPickups.includes(pickup._id))
                );
                setSelectedPickups([]);
            }
        } catch (err) {
            console.error("Error finishing without count:", err);
        }
    };

    // 3) Cancel => show modal for reason
    const handleCancelPickups = () => {
        setIsCancelModalOpen(true);
    };

    // On confirm in the modal
    const confirmCancelPickups = async () => {
        if (!cancelReason.trim()) {
            alert("Cancellation reason is required.");
            return;
        }

        try {
            const response = await finishPickups({
                pickupIds: selectedPickups,
                action: "CANCEL",
                reason: cancelReason,
            });

            if (response.success) {
                // Remove canceled pickups from local state
                setAllPickups((prev) =>
                    prev.filter((pickup) => !selectedPickups.includes(pickup._id))
                );
                setSelectedPickups([]);
            }

            // Close modal + reset reason
            setIsCancelModalOpen(false);
            setCancelReason("");
        } catch (err) {
            console.error("Error canceling pickups:", err);
        }
    };
    const navigate = useNavigate()

    useEffect(() => {
        const pageFromUrl = parseInt(searchParams.get('page')) || 1;
        setCurrentPage(pageFromUrl);
        refresh(pageFromUrl);
    }, []);

    const refresh = (page = 1) => {
        getPickups(page);
        getAllOther();
        getStats();
    }

    const getStats = async () => {
        const response = await getPickupsStats()
        if (response.success) {
            const stats = response.data;

            console.log(stats)
            setStatistics(stats)
        } else {
            setError(response.error);
        }

    }

    const getAllOther = async () => {
        // Lab Locations
        try {
            const response = await fetchLabLocationsOutside();
            if (response.success) {
                setLabLocations(response.data);
            }
        } catch (error) {
            console.log('Error loading lab locations');
        }

        // Facilities
        try {
            const response = await getAllFacilitiesOutside();
            if (response.success) {
                setFacilities(response.data.facilities);
            }
        } catch (error) {
            // setErrorModal('Error loading facilities');
        }


        // Couriers
        try {
            const response = await fetchAllCouriers(1, 99999999);
            if (response.success) {
                setCouriers(response.data.couriers);
            }
        } catch (error) {
            setError('Failed to load couriers');
        }
    };

    const getPickups = async (page = 1) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getAllPickups(page, itemsPerPage);
            if (response.success) {
                const pickups = response.data.pickups;
                console.log(pickups)
                setAllPickups(pickups);


                setCurrentPage(response.data.currentPage);
                setTotalPages(response.data.totalPages);
            } else {
                setError(response.error);
            }
        } catch (error) {
            setError('Failed to load routes');
        }
        setLoading(false);
    };

    const handleSearch = async (currentPage = 1) => {
        setLoading(true);
        try {
            const searchParams = {
                pickupLocationId: pickupLocation || null,    // Extract value from react-select
                dropOffLocationId: dropOffLocation?.value || null,  // Extract value from react-select
                status: statusSelected.value || null,  // Ensure days is an array
                attn: attnSelected.value || null,  // Ensure days is an array
                courier: courier || null,  // Extract value from react-select
                route: route?.value || null,  // Extract value from react-select
                page: currentPage,
                limit: itemsPerPage,
            };

            setSearching(true)

            const response = await searchPickups(searchParams);
            if (response.success) {

                setAllPickups(response.data.pickups);
                setCurrentPage(response.data.currentPage);
                setTotalPages(response.data.totalPages);

            } else if (response.data.totalItems === 0) {
                setAllPickups([])
            } else {
                toast({
                    title: "Oops w!",
                    description: response.error,
                    status: "error",
                    duration: 4000, // duration in milliseconds
                    isClosable: true,
                });

            }
        } catch (error) {
            console.error('Error performing search:', error);
        }
        setLoading(false);
    };

    const handleDeleteRoute = async () => {
        setLoadingProcess(true);
        try {
            if (!cancellationReason) {
                setModalError("You need to type cancellation reason before canceling order")
                setLoadingProcess(false);
                return;
            }

            const response = await cancelPickup(selectedPickup._id, cancellationReason);
            if (response.success) {
                setAllPickups(allPickups.filter(pickup => pickup._id !== selectedPickup._id));
                toast({
                    title: "Canceled Successful",
                    description: `The pickup has been canceled Completely`,
                    status: "success",
                    duration: 3000, // duration in milliseconds
                    isClosable: true,
                });
                setCancellationReason("");
                setModalError("")
                onCloseDeleteModal();
            } else {
                setModalError(response.error);
            }
        } catch (error) {
            setModalError('Error Canceling pickup');
        }
        setLoadingProcess(false);
    };

    const clearSearch = () => {
        setSearching(false);
        setPickupLocation(null);
        setDropOffLocation(null);
        setCourier(null);
        setRoute(null);
        setSelectedStatus([]);
        getPickups();
    };

    const handlePageChanges = (page) => {
        setSearchParams({ page: page.toString() });
        setCurrentPage(page);

        if (searching) {
            handleSearch(page);
        } else {
            getPickups(page);
        }
    };


    const status = (status) => {
        switch (status) {
            case 'PENDING':
                return "Pending";
            case 'PICKED_UP':
                return "Picked Up"
            case 'COMPLETED':
                return 'Received'
            case 'CANCELED':
                return "CANCELED"
            default:
                break;
        }
    }
    function getRequirementsIcons(requirements = {}, type) {
        const icons = [];

        if (requirements.hasDocs) icons.push("Docs");
        if (requirements.hasSupplies) icons.push("Supplies");
        if (requirements.requestPhoto) icons.push("Photo");

        return icons.length > 0 ? (
            <Badge size={"xs"} colorScheme="gray">({icons.join(', ')})</Badge>
        ) : (
            <Badge size={"xs"} colorScheme="gray">-</Badge>
        );
    }


    const handleUpdatePickup = (updatedPickup) => {
        setAllPickups((prevPickups) =>
            prevPickups
                .filter((pickup) => pickup._id !== updatedPickup._id || updatedPickup.status !== 'RECEIVED')
                .map((pickup) => (pickup._id === updatedPickup._id ? updatedPickup : pickup))
        );
        setSelectedPickup(null)
        setIsModalOpen(false)
    };


    return (
        <Box maxW="full" mx="auto">
            <VStack spacing={6} align="stretch">
                <TitleHeader
                    title={`Today's Pickups`}
                    buttonText={hasPermission('createPickup') ? "Add Pickup" : null}
                    onClick={hasPermission('createPickup') ? () => setIsCreateOpen(true) : null}

                    secondButton={true}
                    secondButtonText={showFilter ? "Close Filter" : "Filter"}
                    secondButtonOnClick={() => setShowFilter(!showFilter)}
                    secondButtonIcon={showFilter ? <CloseIcon /> : <FaLongArrowAltDown />}


                    thirdButton={true}
                    thirdButtonText={"Refresh"}
                    thirdButtonOnClick={() => refresh(currentPage)}
                    thirdButtonIcon={<FaSync />}


                    fourthButton={true}
                    fourthButtonText={showCheckboxes ? "Close Finish Pickups" : "Finish Pickups"}
                    fourthButtonOnClick={() => setShowCheckboxes(!showCheckboxes)}
                    fourthButtonIcon={showCheckboxes ? <FaTimes /> : <FaCheckCircle />}

                />


                {showFilter && (
                    <Center>
                        <Card w="full" maxW={{ base: '95%', md: '58%' }} bg={coolors.theadBg}>
                            <Flex
                                direction={{ base: 'column', md: 'row' }}
                                wrap="wrap"
                                p={5}
                                mb={3}
                                gap={4}
                                align="start"
                            >
                                {/* Left Column */}
                                <VStack w={{ base: '100%', md: '48%' }} spacing={4} minW={0}>
                                    <FormControl isRequired w="100%" minW={0}>
                                        <FormLabel>Pickup Location</FormLabel>
                                        <Select
                                            options={facilities.map(fac => ({
                                                value: fac._id,
                                                label: `${fac.name} - ${fac.address.city}`
                                            }))}
                                            onChange={(option) => setPickupLocation(option ? option.value : '')}
                                            value={
                                                pickupLocation
                                                    ? { value: pickupLocation, label: facilities.find(f => f._id === pickupLocation)?.name }
                                                    : null
                                            }
                                            placeholder="Select a facility"
                                            isClearable
                                            styles={getSelectStyles(coolors)}
                                            classNamePrefix="rs"
                                        />
                                    </FormControl>

                                    <FormControl isRequired w="100%" minW={0}>
                                        <FormLabel>Courier</FormLabel>
                                        <Select
                                            classNamePrefix="rs"
                                            options={couriers.map(cou => ({
                                                value: cou._id,
                                                label: `${cou.name} - ${cou.route?.name || "No Route"}`
                                            }))}
                                            onChange={(option) => setCourier(option ? option.value : null)}
                                            value={
                                                courier
                                                    ? { value: courier, label: couriers.find(f => f._id === courier)?.name }
                                                    : null
                                            }
                                            placeholder="Select a courier"
                                            isClearable
                                            styles={getSelectStyles(coolors)}
                                        />
                                    </FormControl>

                                    <FormControl isRequired w="100%" minW={0}>
                                        <FormLabel>Route</FormLabel>
                                        <AsyncSelect
                                            cacheOptions
                                            loadOptions={fetchRouteBySearch}
                                            defaultOptions
                                            onChange={(option) => setRoute(option)}
                                            value={route || null}
                                            placeholder="Select a route"
                                            closeMenuOnSelect
                                            isClearable
                                            styles={getSelectStyles(coolors)}
                                            classNamePrefix="rs"

                                        />
                                    </FormControl>
                                </VStack>

                                {/* Right Column */}
                                <VStack w={{ base: '100%', md: '48%' }} spacing={4} minW={0}>
                                    <FormControl isRequired w="100%" minW={0}>
                                        <FormLabel>Drop off Location</FormLabel>
                                        <Select
                                            cacheOptions
                                            closeMenuOnSelect
                                            isClearable
                                            options={labLocations.map(lab => ({ value: lab._id, label: lab.name }))}
                                            value={dropOffLocation}
                                            onChange={(option) => setDropOffLocation(option || null)}
                                            styles={getSelectStyles(coolors)}
                                            classNamePrefix="rs"

                                        />
                                    </FormControl>

                                    <FormControl isRequired w="100%" minW={0}>
                                        <FormLabel>Status</FormLabel>
                                        <Select
                                            isClearable
                                            options={statusOptions}
                                            value={statusSelected}
                                            onChange={(selectedOptions) => setSelectedStatus(selectedOptions || [])}
                                            styles={getSelectStyles(coolors)}
                                            classNamePrefix="rs"

                                        />
                                    </FormControl>

                                    <FormControl isRequired w="100%" minW={0}>
                                        <FormLabel>Attn</FormLabel>
                                        <Select
                                            isClearable
                                            options={attnOptions}
                                            value={attnSelected}
                                            onChange={(selectedOptions) => setSelectedAttn(selectedOptions || [])}
                                            styles={getSelectStyles(coolors)}
                                            classNamePrefix="rs"

                                        />
                                    </FormControl>
                                </VStack>

                                {/* Buttons */}
                                <VStack w={{ base: '100%', md: 'auto' }} spacing={2} h="100%" mt={7} justify="space-between" minW={0}>
                                    <Button colorScheme="blue" size="sm" onClick={() => handleSearch(1)}>
                                        Search
                                    </Button>

                                    <Box flex="1" />

                                    {searching && (
                                        <Button colorScheme="red" size="sm" onClick={clearSearch}>
                                            Clear
                                        </Button>
                                    )}
                                </VStack>
                            </Flex>
                        </Card>
                    </Center>
                )}





                <SimpleGrid spacing={5} templateColumns='repeat(auto-fill, minmax(350px, 1fr))'>
                    {/* Default Pickups */}
                    <Card borderLeft="6px solid #3182CE">
                        <CardHeader>
                            <HStack>
                                <FaClipboardList color="#3182CE" />
                                <Heading size='md'>Default Pickups</Heading>
                            </HStack>
                        </CardHeader>
                        <CardBody>
                            <Flex align="center" justify="space-between">
                                <VStack align="start" spacing={3}>
                                    <HStack>
                                        <FaClock color="#3182CE" />
                                        <Text fontSize="sm">
                                            <strong>{statistics?.totalPickupsDefaultPending || 0}</strong> Total Today
                                        </Text>
                                    </HStack>
                                    <HStack>
                                        <FaCheckCircle color="#3182CE" />
                                        <Text fontSize="sm">
                                            <strong>{statistics?.pickedUpDefault || 0}</strong> picked up
                                        </Text>
                                    </HStack>
                                </VStack>

                                <FaChevronRight fontSize={20} color="#A0AEC0" />

                                <HStack spacing={2}>
                                    <FaHourglassHalf color="#3182CE" />
                                    <Text fontSize="sm">
                                        <strong>
                                            {(statistics?.totalPickupsDefaultPending || 0) - (statistics?.pickedUpDefault || 0)}
                                        </strong>{' '}
                                        left
                                    </Text>
                                </HStack>
                            </Flex>
                        </CardBody>
                    </Card>



                    {/* On-Call Pickups */}
                    <Card borderLeft="6px solid #D69E2E">
                        <CardHeader>
                            <HStack>
                                <FaPhoneAlt color="#D69E2E" />
                                <Heading size='md'>On-Call Pickups</Heading>
                            </HStack>
                        </CardHeader>
                        <CardBody>
                            <Flex align="center" justify="space-between">
                                <VStack align="start" spacing={3}>
                                    <HStack>
                                        <FaClock color="#D69E2E" />
                                        <Text fontSize="md">
                                            <strong>{(statistics?.onCallPending || 0) + (statistics?.onCallPicked || 0)}</strong> Total Today
                                        </Text>
                                    </HStack>
                                    <HStack>
                                        <FaCheckCircle color="#D69E2E" />
                                        <Text fontSize="md">
                                            <strong>{statistics?.onCallPicked || 0}</strong> picked up
                                        </Text>
                                    </HStack>
                                </VStack>

                                <FaChevronRight fontSize={28} color="#A0AEC0" />

                                <HStack spacing={2}>
                                    <FaHourglassHalf color="#D69E2E" />
                                    <Text fontSize="md">
                                        <strong>{(statistics?.onCallPending || 0)}</strong> left
                                    </Text>
                                </HStack>
                            </Flex>
                        </CardBody>
                    </Card>

                    {/* Route Pickups */}
                    <Card borderLeft="6px solid #38A169">
                        <CardHeader>
                            <HStack>
                                <FaRoute color="#38A169" />
                                <Heading size='md'>Route Pickups</Heading>
                            </HStack>
                        </CardHeader>
                        <CardBody>
                            <Flex align="center" justify="space-between">
                                <VStack align="start" spacing={3}>
                                    <HStack>
                                        <FaClock color="#38A169" />
                                        <Text fontSize="md">
                                            <strong>{statistics?.routePending || 0}</strong> Total Today
                                        </Text>
                                    </HStack>
                                    <HStack>
                                        <FaCheckCircle color="#38A169" />
                                        <Text fontSize="md">
                                            <strong>{statistics?.routePicked || 0}</strong> picked up
                                        </Text>
                                    </HStack>
                                </VStack>

                                <FaChevronRight fontSize={28} color="#A0AEC0" />

                                <HStack spacing={2}>
                                    <FaHourglassHalf color="#38A169" />
                                    <Text fontSize="md">
                                        <strong>{(statistics?.routePending || 0) - (statistics?.routePicked || 0)}</strong> left
                                    </Text>
                                </HStack>
                            </Flex>
                        </CardBody>
                    </Card>



                    {/* Supplies + Drop-Offs */}
                    <Card borderLeft="6px solid #805AD5">
                        <CardHeader>
                            <HStack>
                                <FaBoxes color="#805AD5" />
                                <Heading size='md'>Supplies & Drop-Offs</Heading>
                            </HStack>
                        </CardHeader>
                        <CardBody>
                            <VStack align="start" spacing={1}>
                                <Text><strong>{statistics?.suppliesPending || 0}</strong> supplies pending</Text>
                                <Text><strong>{statistics?.dropOffsPending || 0}</strong> drop-offs pending</Text>
                            </VStack>
                        </CardBody>
                    </Card>
                </SimpleGrid>





                <Divider />
                {showCheckboxes && (
                    <>
                        <SimpleGrid spacing={4} templateColumns='repeat(auto-fill, minmax(20%, 1fr))'>
                            <Button
                                onClick={handleFinishWithCount}
                                colorScheme="blue"
                                size={"md"}
                                ml={2}
                                isDisabled={selectedPickups.length === 0}
                            >
                                Finish with count update
                            </Button>
                            <Button
                                onClick={handleFinishWithoutCount}
                                colorScheme="green"
                                ml={2}
                                isDisabled={selectedPickups.length === 0}
                            >
                                Finish without count update
                            </Button>
                            <Button
                                onClick={handleCancelPickups}
                                colorScheme="red"
                                ml={2}
                                isDisabled={selectedPickups.length === 0}
                            >
                                Cancel selected pickups
                            </Button>
                            <Button onClick={toggleCheckboxes} colorScheme="purple" ml={2}>
                                <CloseIcon mr={2} boxSize={4} />  Close Selecting
                            </Button>
                        </SimpleGrid>
                        <Divider />
                    </>
                )}

                {loading ?
                    <Center mt={"20%"}>
                        <Loading />
                    </Center>
                    :
                    <>
                        {error ? (
                            <AccessDenied msg={error} />
                        )
                            :
                            allPickups.length > 0 ? (
                                <>
                                    <Table size="sm">
                                        <Thead bg={coolors.theadBg}>
                                            <Tr>
                                                {showCheckboxes && <Th>SP</Th>}
                                                {!showCheckboxes && <Th>#ID</Th>}
                                                <Th>Pickup</Th>
                                                <Th>Drop</Th>
                                                <Th>Courier</Th>
                                                <Th>Type</Th>
                                                <Th>Requirements</Th>
                                                <Th>Route</Th>
                                                <Th>SC</Th>
                                                <Th>Time</Th>
                                                <Th textAlign="right">Actions</Th>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {allPickups?.map((pickup, index) => (
                                                <Tr
                                                    fontWeight="bold"
                                                    key={pickup._id + "_" + index}
                                                    borderBottom="2px solid"
                                                    borderColor={coolors.borderColor}
                                                    bg={
                                                        pickup.type === "DropOffOnly"
                                                            ? coolors.dropOffBg
                                                            : pickup.type === "Supplies"
                                                                ? coolors.suppliesBg
                                                                : pickup.status === "PICKED_UP" && pickup.samplesCount === 0
                                                                    ? coolors.pickedBg
                                                                    : index % 2 === 0
                                                                        ? coolors.rowBgEven
                                                                        : coolors.rowBgOdd
                                                    }
                                                    color={
                                                        pickup.type === "Supplies"
                                                            ? coolors.rowHoverColor
                                                            : coolors.textColor
                                                    }
                                                    _hover={{
                                                        bg: coolors.rowHoverBg,
                                                        color: "white",
                                                    }}
                                                >
                                                    {showCheckboxes && (
                                                        <Td>
                                                            <Checkbox
                                                                isChecked={selectedPickups.includes(pickup._id)}
                                                                onChange={() => handleCheckboxChange(pickup._id)}
                                                            />
                                                        </Td>
                                                    )}
                                                    {!showCheckboxes && (
                                                        <Td maxW={1}>
                                                            <PopoverId
                                                                place="Pickup"
                                                                index={(currentPage - 1) * itemsPerPage + index}
                                                                content={pickup._id}
                                                            />
                                                        </Td>
                                                    )}

                                                    {/* Pickup Location */}
                                                    <Td>
                                                        {pickup?.pickupLocation?.name ? (
                                                            <Popover placement="top">
                                                                <PopoverTrigger>
                                                                    <span
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        <FaMapMarkedAlt style={{ marginRight: "6px" }} />
                                                                        <b>
                                                                            {pickup.pickupLocation?.lab?.name
                                                                                ? `${pickup.pickupLocation.lab.name} - `
                                                                                : ""}
                                                                            {pickup.pickupLocation.name}
                                                                        </b>
                                                                    </span>
                                                                </PopoverTrigger>
                                                                <PopoverContent
                                                                    bg={coolors.popoverBg}
                                                                    color={coolors.popoverColor}
                                                                    border="none"
                                                                    maxW="300px"
                                                                >
                                                                    <PopoverArrow bg={coolors.popoverBg} />
                                                                    <PopoverBody>
                                                                        {pickup.pickupLocation.name}
                                                                        <br />
                                                                        <br />
                                                                        {[
                                                                            pickup.pickupLocation.address?.address1,
                                                                            pickup.pickupLocation.address?.address2,
                                                                            pickup.pickupLocation.address?.city,
                                                                            pickup.pickupLocation.address?.state,
                                                                            pickup.pickupLocation.address?.zip,
                                                                        ]
                                                                            .filter(Boolean)
                                                                            .join(", ")}
                                                                    </PopoverBody>
                                                                </PopoverContent>
                                                            </Popover>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </Td>

                                                    {/* Drop Off Location */}
                                                    <Td>
                                                        {pickup?.dropOffLocation?.name ? (
                                                            <Popover placement="top">
                                                                <PopoverTrigger>
                                                                    <span
                                                                        style={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        <FaMapMarkedAlt style={{ marginRight: "6px" }} />
                                                                        <b>{pickup.dropOffLocation.name}</b>
                                                                    </span>
                                                                </PopoverTrigger>
                                                                <PopoverContent
                                                                    bg={coolors.popoverBg}
                                                                    color={coolors.popoverColor}
                                                                    border="none"
                                                                    maxW="300px"
                                                                >
                                                                    <PopoverArrow bg={coolors.popoverBg} />
                                                                    <PopoverBody>
                                                                        {pickup.dropOffLocation.name}
                                                                        <br />
                                                                        <br />
                                                                        {[
                                                                            pickup.dropOffLocation.address?.address1,
                                                                            pickup.dropOffLocation.address?.address2,
                                                                            pickup.dropOffLocation.address?.city,
                                                                            pickup.dropOffLocation.address?.state,
                                                                            pickup.dropOffLocation.address?.zip,
                                                                        ]
                                                                            .filter(Boolean)
                                                                            .join(", ")}
                                                                    </PopoverBody>
                                                                </PopoverContent>
                                                            </Popover>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </Td>

                                                    {/* Courier */}
                                                    <Td>
                                                        <Link
                                                            to={`/couriers/details/${pickup.courier?._id}`}
                                                            style={{ display: "flex", alignItems: "center" }}
                                                        >
                                                            <FaUser style={{ marginRight: "6px" }} />
                                                            <b>{pickup.courier?.name}</b>
                                                        </Link>
                                                    </Td>

                                                    {/* Type */}
                                                    <Td>
                                                        <Tooltip
                                                            label={
                                                                pickup.type === "DropOffOnly"
                                                                    ? "Drop Off"
                                                                    : pickup.type === "Default"
                                                                        ? "Pickup"
                                                                        : pickup.type
                                                            }
                                                            placement="top"
                                                        >
                                                            <Badge
                                                                cursor="default"
                                                                colorScheme={
                                                                    pickup.type === "DropOffOnly"
                                                                        ? "pink"
                                                                        : pickup.type === "Supplies"
                                                                            ? "purple"
                                                                            : "orange"
                                                                }
                                                            >
                                                                {pickup.type === "DropOffOnly"
                                                                    ? "D"
                                                                    : pickup.type === "Default"
                                                                        ? "P"
                                                                        : pickup.type === "Supplies"
                                                                            ? "S"
                                                                            : ""}
                                                            </Badge>
                                                        </Tooltip>
                                                    </Td>

                                                    {/* Requirements */}
                                                    <Td>{getRequirementsIcons(pickup.requirements, pickup.type)}</Td>

                                                    {/* Route */}
                                                    <Td>
                                                        <Tooltip
                                                            label={pickup.routeId?.name || "On Call"}
                                                            placement="top"
                                                        >
                                                            <Badge
                                                                cursor="default"
                                                                colorScheme={pickup.routeId?.name ? "red" : "green"}
                                                            >
                                                                {pickup.routeId?.name || "On Call"}
                                                            </Badge>
                                                        </Tooltip>
                                                    </Td>

                                                    {/* Sample Count */}
                                                    <Td>
                                                        {pickup.status === "PENDING" ? (
                                                            <Badge colorScheme="blue">{status(pickup.status)}</Badge>
                                                        ) : pickup.samplesCount == 0 ? (
                                                            <Badge
                                                                bg={coolors.sampleZeroBg}
                                                                textColor={coolors.sampleTextColor}
                                                                borderRadius={5}
                                                                px={5}
                                                            >
                                                                {pickup.samplesCount}
                                                            </Badge>
                                                        ) : (
                                                            <Badge
                                                                bg={coolors.sampleNonZeroBg}
                                                                textColor={coolors.sampleTextColor}
                                                                borderRadius={5}
                                                                px={5}
                                                            >
                                                                {pickup.samplesCount}
                                                            </Badge>
                                                        )}
                                                    </Td>


                                                    {/* Time */}
                                                    <Td fontSize={14}>
                                                        {pickup?.timestamps?.pickupTime ? (
                                                            new Date(pickup?.timestamps?.pickupTime).toLocaleTimeString(
                                                                [],
                                                                { hour: "numeric", minute: "2-digit" }
                                                            )
                                                        ) : (
                                                            <Center>
                                                                <Popover placement="top">
                                                                    <PopoverTrigger>
                                                                        <Text cursor="pointer">
                                                                            <FaClock color={coolors.borderColor} size={15} />
                                                                        </Text>
                                                                    </PopoverTrigger>
                                                                    <PopoverContent
                                                                        p={2}
                                                                        bg={coolors.popoverBg}
                                                                        color={coolors.popoverColor}
                                                                        border="none"
                                                                        maxW="200px"
                                                                    >
                                                                        <PopoverArrow bg={coolors.popoverBg} />
                                                                        <PopoverBody whiteSpace="pre-wrap">
                                                                            Not picked up yet!
                                                                            {`\n\n`}
                                                                            Created At{" "}
                                                                            {new Date(
                                                                                pickup?.createdAt
                                                                            ).toLocaleTimeString([], {
                                                                                hour: "numeric",
                                                                                minute: "2-digit",
                                                                            })}
                                                                        </PopoverBody>
                                                                    </PopoverContent>
                                                                </Popover>
                                                            </Center>
                                                        )}
                                                    </Td>

                                                    {/* Actions (unchanged, uses buttons with colorSchemes) */}
                                                    <Td textAlign="right">
                                                        <HStack justifyContent="flex-end" spacing={1}>

                                                            <PickupImageLightbox pickup={pickup} />


                                                            {pickup.type == "Default" &&
                                                                <Tooltip label="View Pickup" placement='top' >
                                                                    <Button onClick={() => { navigate('/pickups/view/' + pickup._id) }} size={"xs"} colorScheme="green">
                                                                        <ViewIcon />
                                                                    </Button>
                                                                </Tooltip>
                                                            }
                                                            <Tooltip label="Add/View notes" placement='top' >
                                                                <Button onClick={() => { setSelectedPickup(pickup); onNoteModalOpen(); }} size={"xs"} colorScheme="gray">
                                                                    <FaBook style={{ marginRight: 3 }} />
                                                                </Button>
                                                            </Tooltip>
                                                            {hasPermission('updatePickup') && pickup.type == "Default" &&
                                                                <>
                                                                    <Tooltip label="Edit Pickup" placement='top' >
                                                                        <Button onClick={() => {
                                                                            setSelectedPickup(pickup);
                                                                            setIsModalOpen(true)
                                                                        }} size={"xs"} colorScheme="blue">
                                                                            <EditIcon />
                                                                        </Button>
                                                                    </Tooltip>

                                                                </>
                                                            }
                                                            {hasPermission('updatePickup') &&

                                                                <Tooltip label="Transfer this pickup" placement='top' >
                                                                    <Button
                                                                        size="xs"
                                                                        colorScheme="purple"
                                                                        onClick={() => {
                                                                            setSelectedPickup(pickup);
                                                                            onOpenTransferModal();
                                                                        }}
                                                                    >
                                                                        <FaShare />
                                                                    </Button>
                                                                </Tooltip>


                                                            }
                                                            {hasPermission('deletePickup') &&
                                                                <Button onClick={() => { setSelectedPickup(pickup); onOpenDeleteModal(); }} size={"xs"} colorScheme="red">
                                                                    <DeleteIcon />
                                                                </Button>
                                                            }
                                                        </HStack>
                                                    </Td>
                                                </Tr>
                                            ))}
                                        </Tbody>
                                    </Table>

                                    <Pagination
                                        currentPage={currentPage}
                                        totalPages={totalPages}
                                        handlePageChange={handlePageChanges}
                                    />
                                </>

                            ) : (
                                <AccessDenied msg="Nothing here yet !" icon='info' />
                            )}
                        {selectedPickup &&
                            <>
                                {/* Cancel Pickup */}
                                <Modal isOpen={isDeleteModalOpen} onClose={onCloseDeleteModal}>
                                    <ModalOverlay />
                                    <ModalContent>
                                        <ModalHeader>Confirm Cancellation</ModalHeader>
                                        <ModalBody>

                                            {modalError &&
                                                <Alert mb={5} status='error'>
                                                    <AlertDescription>{modalError}</AlertDescription>
                                                </Alert>
                                            }


                                            Are you sure you want to cancel this pickup ?
                                            <br /><br />
                                            <strong>{selectedPickup?.pickupLocation?.name || ''}</strong>
                                            <br /><br />
                                            <FormControl mb={3} isRequired>
                                                <FormLabel>Cancellation Reason</FormLabel>
                                                <Input
                                                    type="text"
                                                    value={cancellationReason}
                                                    onChange={(e) => setCancellationReason(e.target.value)}
                                                    placeholder="Cancellation Reason"
                                                />
                                            </FormControl>

                                        </ModalBody>
                                        <ModalFooter>
                                            <Button mr={5} isLoading={loadingProcess} colorScheme="red" onClick={handleDeleteRoute}>Yes</Button>
                                            <Button onClick={onCloseDeleteModal}>No</Button>
                                        </ModalFooter>
                                    </ModalContent>
                                </Modal>


                            </>
                        }



                        {selectedPickup && selectedPickup.type != 'DropOffOnly' && (
                            <>

                                {/* Add Note to Pickup */}
                                <Modal size={"4xl"} scrollBehavior='inside' isOpen={isNoteModalOpen} onClose={onCloseNoterModal}>
                                    <ModalOverlay />
                                    <ModalContent>
                                        <ModalHeader>Add Note to {selectedPickup?.pickupLocation?.name || selectedPickup?.dropOffLocation?.name}
                                            <Badge ml={5} colorScheme={"blue"}>
                                                {status(selectedPickup.status)}
                                            </Badge>
                                        </ModalHeader>
                                        <ModalBody>

                                            <PickupNotes pickupId={selectedPickup._id} existingNotes={selectedPickup.notes} addNote={selectedPickup?.finishedAt ? false : true} />
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button onClick={onCloseNoterModal}>Close</Button>
                                        </ModalFooter>
                                    </ModalContent>
                                </Modal>




                                {/* Edit Pickup */}
                                <EditPickupModal
                                    isOpen={isModalOpen}
                                    onClose={() => {
                                        setSelectedPickup(null)
                                        setIsModalOpen(false)
                                    }}
                                    pickup={selectedPickup}
                                    onUpdatePickup={handleUpdatePickup}
                                />
                            </>

                        )}
                    </>
                }




                <CreatePickupModal
                    isOpen={isCreateOpen}
                    onClose={() => setIsCreateOpen(false)}
                    onCreate={() => getPickups()}
                />

                <Modal isOpen={isCancelModalOpen} onClose={() => setIsCancelModalOpen(false)}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Cancel Pickups</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <FormControl>
                                <FormLabel>Reason for cancellation</FormLabel>
                                <Textarea
                                    placeholder="Enter reason"
                                    value={cancelReason}
                                    onChange={(e) => setCancelReason(e.target.value)}
                                />
                            </FormControl>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                colorScheme="red"
                                mr={3}
                                onClick={confirmCancelPickups}
                            >
                                Confirm
                            </Button>
                            <Button variant="ghost" onClick={() => setIsCancelModalOpen(false)}>
                                Close
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>



                <Modal isOpen={isTransferModalOpen} onClose={onCloseTransferModal}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Transfer {selectedPickup?.pickupLocation?.name}</ModalHeader>
                        <ModalBody>

                            <Text mb={4}>Select courier to transfer this pickup to</Text>
                            <FormControl isRequired>
                                <Select
                                    classNamePrefix="rs"
                                    options={couriers.map(cou => ({
                                        value: cou._id,
                                        label: `${cou.name} - ${cou.route?.name || "No Route"}`
                                    }))}
                                    onChange={(option) => setTransferCourier(option)}
                                    value={transferCourier || null}
                                    placeholder="Select a courier"
                                    isClearable
                                    styles={getSelectStyles(coolors)}
                                />

                            </FormControl>
                        </ModalBody>
                        <ModalFooter>
                            <Button mr={5} isLoading={transfering} colorScheme="red" onClick={handleTransferPickup}>Transfer</Button>
                            <Button onClick={onCloseTransferModal} isLoading={transfering} >Close</Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>


            </VStack >
        </Box >
    );
};

export default AllPickups;
